import styled from "styled-components";

const FirstContentImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export default FirstContentImage;